import { useBlockOrFieldReadOnly } from 'components/common-form/hooks/useBlockOrFieldReadOnly';
import { useData } from 'components/common-form/hooks/useData';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { usePatchedFieldHighlight } from 'components/common-form/hooks/usePatchedFieldHighlight';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';
import { ToggleField } from './ToggleField/ToggleField';

export type BatchToggleFieldProps = ProductNodeBuilderProps & {
  switchSize?: 'md' | 'sm';
  useFormControlStyle?: boolean;
  useEditedStyle?: boolean;
  withStateLabel?: boolean;
};
export const BatchToggleField: FC<BatchToggleFieldProps> = ({
  node: { id },
  switchSize,
  useFormControlStyle,
  useEditedStyle,
  withStateLabel,
  tabIndex,
}) => {
  const [value, setValue] = useData<boolean>(id);
  const isReadOnly = useBlockOrFieldReadOnly(id);
  const translationKey = useFieldTranslationKey(id);
  const patchedFieldClassName = usePatchedFieldHighlight(id);

  return (
    <BlockOrientationFormGroup inputId={id} workspaceType="newBatch" className={patchedFieldClassName}>
      <ToggleField
        id={id}
        key={id}
        e2e={translationKey}
        isDisabled={isReadOnly}
        value={value ?? false}
        onChange={setValue}
        useFormControlStyle={useFormControlStyle}
        switchSize={switchSize}
        useEditedStyle={useEditedStyle}
        withStateLabel={withStateLabel}
        tabIndex={tabIndex}
      />
    </BlockOrientationFormGroup>
  );
};

ToggleField.displayName = 'BatchToggleField';
